import { createAsyncThunk } from "@reduxjs/toolkit";
import { IWorker } from "../../types/filterFields";
import { client } from "../../lib/axios";

export const getKanbanWorkers = createAsyncThunk(
  "kanban/getKanbanWorkers",
  async ({
    lastDays,
    provincia,
    sede,
    provinceUserSites,
  }: {
    lastDays?: number;
    provincia?: string | null;
    sede?: string | string[] | null;
    provinceUserSites?: string[];
  }): Promise<{ rows: IWorker[] }> => {
    const sedeParam = Array.isArray(sede)
      ? sede.filter(Boolean).join(",")
      : sede || undefined;

    const response = await client.get("/kanban/workers/latest", {
      params: {
        ...(lastDays ? { lastDays } : {}),
        ...(provincia ? { provincia } : {}),
        ...(sedeParam ? { sede: sedeParam } : {}),
        ...(provinceUserSites?.length
          ? { provinceUserSites: provinceUserSites.join(",") }
          : {}),
      },
    });

    return response.data as { count: number; rows: IWorker[] };
  }
);

export const updateKanbanBoard = createAsyncThunk(
  "kanban/updateKanbanBoard",
  async ({
    workerId,
    board,
  }: {
    workerId: string;
    board: string;
  }): Promise<{
    success: boolean;
    updated: { codice_fiscale: string; board: number };
  }> => {
    const response = await client.patch("/kanban/workers", {
      codiceFiscale: workerId,
      board,
    });

    return response.data as {
      success: boolean;
      updated: { codice_fiscale: string; board: number };
    };
  }
);
